<template>


        <section class="postal-section">
            <div class="result-title">Postal Entries
                <div class="content">
                    <select class="dropdown"
                            v-model="selectedCompetitionId"
                            @change="getPostalEntryData(selectedCompetitionId)">
                        <option disabled :value="null">Select a Competition</option>
                        <option v-for="competition in activeCompetitions"
                                :key="competition.competitionId"
                                :value="competition.competitionId">
                            {{ competition.competitionTitle }}
                        </option>
                    </select>
                    <button :disabled="isSubmitting" class="postal-button" @click="addPostalEntry">
                        <span v-if="!isSubmitting">Add Postal Entry</span>
                        <LoaderDots v-if="isSubmitting" />
                    </button>
                </div>
            </div>
           
         
                <div class="postal-grid">
                    <label for="id"><strong>Id:</strong></label>
                    <input id="id" name="id" disabled :value="postalEntryData.competitionId" readonly>


                    <label for="competition"><strong>Competition</strong></label>
                    <input id="competition" name="competition" disabled :value="postalEntryData.competitionName" readonly>

                    <label for="limit"><strong>Ticket Limit:</strong></label>
                    <input id="limit" name="limit" disabled :value="postalEntryData.ticketLimit" readonly>


                    <label for="sold"><strong>Tickets Sold:</strong></label>
                    <input id="sold" name="sold" disabled :value="postalEntryData.ticketsSold" readonly>


                    <label for="available"><strong>Tickets Available:</strong></label>
                    <input id="available" name="available" disabled :value="postalEntryData.ticketsAvailable" readonly>


                    <label for="startDate"><strong>Start Date:</strong></label>
                    <input id="startDate" name="startDate" disabled :value="postalEntryData.startDate" readonly>


                    <label for="endDate"><strong>End Date:</strong></label>
                    <input id="endDate" name="startDate" disabled :value="postalEntryData.endDate" readonly>

                    <label for="userTicketCap"><strong>User Ticket Cap:</strong></label>
                    <input id="userTicketCap" name="userTicketCap" disabled :value="postalEntryData.userTicketCap" readonly>


                    <label for="ticketsPurchasedByUser"><strong>Tickets Purchased by User:</strong></label>
                    <input id="ticketsPurchasedByUser" name="ticketsPurchasedByUser" disabled :value="postalEntryData.ticketsPurchasedByUser" readonly>


                    <label for="ticketsAvailableToUser"><strong>Tickets Available to User:</strong></label>
                    <input id="ticketsAvailableToUser" name="ticketsAvailableToUser" disabled :value="postalEntryData.ticketsAvailableToUser" readonly>

                
                </div>
                 
             
         
        </section>

</template>

<script lang="ts">
import { defineComponent, onMounted, ref } from "vue";
import { useRoute } from "vue-router";
import competitionService from "../services/competition-service";
import ActiveCompetitionsResponse from "../responses/ActiveCompetitionsResponse";
import CompetitionDetailsPostalEntry from "../models/CompetitionDetailsPostalEntry";
import { showAlert } from "../utils/global";
import LoaderDots from "./LoadingButtonDots.vue";

 export default defineComponent({
     components: {
 
         LoaderDots,
     },
  setup() {
    const route = useRoute();
    const userId = Number(route.params.userId);
    const activeCompetitions = ref<ActiveCompetitionsResponse[]>([]);
    const postalEntryData = ref<CompetitionDetailsPostalEntry>(
      {} as CompetitionDetailsPostalEntry
    );
    const selectedCompetitionId = ref<number | null>(null);

              const isSubmitting = ref(false); // New state for button disabling

    const getActiveCompetitions = async () => {
      try {
        const response = await competitionService.getActiveCompetitions();
        activeCompetitions.value = response;
      } catch (error) {
        console.error("Error fetching active competitions:", error);
      }
    };

    onMounted(async () => {
      await getActiveCompetitions();
    });

    const getPostalEntryData = async (competitionId: number) => {
      try {
        const data =
          await competitionService.getCompetitionDetailsForPostalEntry(
            competitionId,
            userId
          );
        postalEntryData.value = data;
      } catch (error) {
        console.error("Error fetching postal entry data:", error);
      }
    };

    const addPostalEntry = async () => {
      try {

            isSubmitting.value = true;
        const response = await competitionService.addPostalEntry(
          userId,
          selectedCompetitionId.value
        );
        if (response.data) {
          showAlert(
            "Postal Entry Added",
            "1 free postal entry has been added to the user's account.",
            "success"
          );

            isSubmitting.value = false;

          selectedCompetitionId.value = null;
          postalEntryData.value = {} as CompetitionDetailsPostalEntry;
        }
      } catch (error: any) {
        const message =
          error?.response?.data?.errors?.[0] ??
          error?.response?.data?.message ??
          error?.message ??
          "An unexpected error occurred.";

        showAlert(
          "Failed to Add Postal Entry",
          `There was a problem adding the postal entry: ${message}`,
          "error"
        );

          isSubmitting.value = false;
      }
    };

    return {
      activeCompetitions,
      postalEntryData,
      selectedCompetitionId,
      getPostalEntryData,
      addPostalEntry,

      isSubmitting,
    };
  },
});
</script>

<style scoped>
.result-title {
  position: relative;
  min-height: 89px;
  display: grid;
  background-color: var(--clr-primary);
  padding: 1rem 1rem;
  margin-inline: 2rem;
  color: white;
  font-size: 24px;
  border-radius: 3px;
  box-shadow: 0 10px 30px -12px rgba(0, 0, 0, 0.42),
    0 4px 25px 0px rgba(0, 0, 0, 0.12), 0 8px 10px -5px rgba(0, 0, 0, 0.2);
  align-items: center;
  z-index: 1;
}

    .postal-grid {
        display: grid;  
        margin: auto;
        position: relative;
        background-color: #fff;
        padding: 80px 40px 20px 40px;
        box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.14);
        margin-top: -50px;
    }

    .dropdown {
        width: 100%;
        padding: 1rem;
     
        font-size: 16px;
        border: 1px solid #ccc;
        border-radius: 3px;
        background-color: white;
    }



.info-grid p {
  margin: 4px 0;
  font-size: 16px;
}

    .postal-button {
    
        background-color: orangered;
        max-width: 300px;
        padding: 1rem 1rem;
    height: 60px;
        color: white;
        font-size: 24px;
        border-radius: 3px;
        border: none;
        width: 100%;
        cursor: pointer;
    }

strong {
  font-weight: 600;
}



    label {
        padding-top: 1rem;
    }

    input {
        padding: 1rem;
    }


    .content {
        display: flex;
        gap: 2rem;

    }
</style>
